import ReactComponentMounter from '../utils/react-component-mounter';

import ActivityPublic from '../apps/activities/ActivityPublic';

ReactComponentMounter.register({
  ActivityPublic
});
